import React from 'react'
import {Box, Center, Heading, Text} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import textStyles from '../../../theme/foundations/textStyles'
import {useForm} from 'react-hook-form'
import useSearchFields from '../../../components/forms/useSearchFields'
import Search from '../../../components/search'

const CartSearch = () => {
    const form = useForm({
        defaultValues: {searchTerm: ''}
    })

    const fields = useSearchFields({form})

    return (
        <Box mt={8} px={{base: 6, lg: 10}} py={10} backgroundColor="stokkeGray.mid">
            <Center>
                <Heading as="h2" {...textStyles['Regular 2XLarge']} mb={4}>
                    <FormattedMessage
                        defaultMessage="It’s rather empty here."
                        id="empty_cart.headline"
                    />
                </Heading>
            </Center>
            <Text mb={{base: 8}} lineHeight="20.8px" align="center">
                <FormattedMessage
                    defaultMessage="Why don’t you start exploring or type in what you’re looking for:"
                    id="empty_cart.message.search_text"
                />
            </Text>
            <Search
                {...fields.searchTerm}
                variant="flushed"
                withSearchButton={true}
                containerProps={{position: {base: 'static', '2xl': 'relative'}}}
                dropdownProps={{marginLeft: {md: 0}, paddingX: {base: 10, md: 8}}}
            />
        </Box>
    )
}

export default CartSearch
